import * as React from 'react';
import * as qs from 'query-string';
import * as _ from 'lodash';
import { connect, Dispatch } from 'react-redux';
import { InputGroup, FormControl, Glyphicon, Button, Panel, Alert, Well } from 'react-bootstrap';
import { IApplicationState, AppActionCreators, AdpDonorActionCreators } from '@nkr/store/index';
import { IBaseResponse, IAdpDonor, IAdpCertificatePrintResponse, IAdpBatchInfoResponse, IAdpBatchInfo, IAdpVoucherHolder } from '../../models/index';
import { IAdpDonorListResponse } from '@nkr/store/voucher/index';
import { AdpVoucherBatchType, AdpVoucherPrintStatus } from '@nkr/enums/index';
import { PanelTitleWrapper, TableContainer, TableWrapper } from './styles';
import BatchInfoRow from './batch-info-row';
import DonorRow from './donor-row';
import ConfirmPrint from './confirm-print';
import Message from './message';
import Filter from './filter';
import { ConfirmAction } from './confirm-action';
import { downloadFile } from '@nkr/services/download-file';

interface IOwnProps { }

interface IAdpDonorStateProps {
    userId: number
}

interface IAdpDonorDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getDonors: (firstName: string, lastName: string, email: string, alias: string, isAvailable: boolean, isNotAvailable: boolean) => Promise<IAdpDonorListResponse>,
    printDonorCertificates: (donorIds: number[]) => Promise<IAdpCertificatePrintResponse>,
    printVouchers: (voucherHolderIds: number[]) => Promise<IAdpCertificatePrintResponse>,
    getManifest: (url: string) => void,
    getBatches: () => Promise<IAdpBatchInfoResponse>,
    updateDonorPrintStatus: (donorId: number, printStatus: AdpVoucherPrintStatus) => Promise<IBaseResponse>,
    updateVoucherHolderPrintStatus: (voucherHolderId: number, printStatus: AdpVoucherPrintStatus) => Promise<IBaseResponse>,
    resetAll: () => Promise<IBaseResponse>,
    downloadBatchManifest: (batchInfo: IAdpBatchInfo) => Promise<any>,
    downloadBatchPdf: (batchInfo: IAdpBatchInfo) => Promise<any>
    downloadBatchCsv: (batchInfo: IAdpBatchInfo) => Promise<any>
}

type TAdpDonorProps = IAdpDonorStateProps & IAdpDonorDispatchProps & IOwnProps

interface IState {
    donors: IAdpDonor[],
    totalDonors: number,
    totalDonorsWithVoucherHolders: number,
    totalVoucherHolders: number,
    batches: IAdpBatchInfo[],
    manifestLink: string,
    pdfLink: string,
    userId: number,
    hasCertsAlreadyMarkedSent: boolean,
    showCompletedRows: boolean,
    search: string,
    status: number,
    donorStatus: number,
    firstName: string,
    lastName: string,
    email: string,
    alias: string,
    buttons: number[],
    modal: {
        show: boolean,
        title: string,
        message: string
    },
    confirm: {
        show: boolean,
        action: ConfirmAction,
        title: string,
        message: string,
        list: IAdpDonor[] | IAdpVoucherHolder[]
    }
}

class AdpDonor extends React.Component<TAdpDonorProps, IState> {
    readonly state: IState = {
        donors: [],
        totalDonors: 0,
        totalDonorsWithVoucherHolders: 0,
        totalVoucherHolders: 0,
        batches: [],
        manifestLink: '',
        pdfLink: '',
        userId: -1,
        hasCertsAlreadyMarkedSent: false,
        showCompletedRows: false,
        search: '',
        status: 0,
        donorStatus: -1,
        firstName: '',
        lastName: '',
        email: '',
        alias: '',
        buttons: [1, 0],
        modal: {
            show: false,
            title: '',
            message: ''
        },
        confirm: {
            show: false,
            action: ConfirmAction.PrintAllDonorCertificates,
            title: '',
            message: '',
            list: []
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(window.location.search);
        let firstName = parsed.firstName != null ? parsed.firstName : this.state.firstName;
        let lastName = parsed.lastName != null ? parsed.lastName : this.state.lastName;
        let email = parsed.email != null ? parsed.email : this.state.email;
        let alias = parsed.alias != null ? parsed.alias : this.state.alias;
        let buttons = parsed.buttons != null ? _.split(parsed.buttons, ',').map(b => parseInt(b)) : this.state.buttons;

        let isAvailable = buttons[0] > 0;
        let isNotAvailable = buttons[1] > 0;

        this.props.showLoading('Getting data, one moment please...').then(() => {
            Promise.all([
                this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable),
                this.props.getBatches()]
            ).then(([donorsResponse, batchesReponse]) => {
                let { totalDonors, totalDonorsWithVoucherHolders, totalVoucherHolders, donors } = donorsResponse.data.results;
                let hasCertsAlreadyMarkedSent = this.showDisabledButtonsAlert(this.props.userId, donors);
                let batches = batchesReponse.data.results;

                this.setState({
                    totalDonors,
                    totalDonorsWithVoucherHolders,
                    totalVoucherHolders,
                    donors,
                    batches,
                    hasCertsAlreadyMarkedSent,
                    firstName,
                    lastName,
                    email,
                    alias,
                    buttons
                })
                this.props.hideLoading();
            }).catch(() => {
                this.props.hideLoading();
            });
        });
    }

    getFilteredData = () => {
        return this.state.donors.filter(x => {
            let aliasSearch = x.alias.toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0;
            let donorName = x.name.toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0;
            let voucherHolders = x.voucherHolders.filter(vh => vh.fullName.toLowerCase().indexOf(this.state.search.toLowerCase()) >= 0).length > 0;
            let status = true;
            let donorStatus = true;

            if (this.state.status == 1) {
                status = x.printStatus == AdpVoucherPrintStatus.ReadyToPrint;
            }

            if (this.state.status == 2) {
                status = x.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.ReadyToPrint).length > 0;
            }

            if (this.state.status == 3) {
                status = x.printStatus == AdpVoucherPrintStatus.MarkSentUser2;
            }

            if (this.state.status == 4) {
                status = x.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.MarkSentUser2).length > 0;
            }

            if (this.state.status == 5) {
                status = x.printStatus == AdpVoucherPrintStatus.Printed || x.printStatus == AdpVoucherPrintStatus.MarkSentUser1;
            }

            if (this.state.status == 6) {
                status = x.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.Printed || vh.printStatus == AdpVoucherPrintStatus.MarkSentUser1).length > 0;
            }

            if (this.state.donorStatus == 1) {
                donorStatus = x.hasDonated == true;
            }

            if (this.state.donorStatus == 0) {
                donorStatus = x.hasDonated == false;
            }

            return (aliasSearch || donorName || voucherHolders) && status && donorStatus;
        });
    }

    showDisabledButtonsAlert = (userId: number, adpDonors: IAdpDonor[]) => {
        let s = adpDonors.filter(donor => {
            if (donor.adpCertFirstCheckUserId == userId) {
                return true;
            } else {
                let y = donor.voucherHolders.filter(vh => vh.certificateFirstCheckUserId == userId);

                if (y.length > 0) {
                    return true;
                }
            }
        });

        return s.length > 0;
    }

    printAllDonorCertificates = () => {
        let { firstName, lastName, email, alias, buttons } = this.state;

        let isAvailable     = buttons[0] > 0;
        let isNotAvailable  = buttons[1] > 0;

        let donorList       = this.state.donors
                            .filter(x => x.printStatus == AdpVoucherPrintStatus.ReadyToPrint
                                && x.hasDonated == true)
                            .slice(0, 500)
                            .map(x => x.id);

        if (donorList.length == 0) {
            alert('All vouchers have been printed.');
            return;
        }

        this.props.showLoading('Creating certificates, one moment please...').then(() => {
            this.props.printDonorCertificates(donorList).then(response => {
                if (response.data.success) {
                    Promise.all([
                        this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable),
                        this.props.getBatches()]
                    ).then(([donorsResponse, batchResponse]) => {
                        let { donors } = donorsResponse.data.results;
                        let batches = batchResponse.data.results;

                        this.setState({
                            donors,
                            batches
                        });

                        this.props.hideLoading();
                        this.showModal('Print All Donor Certificates', 'Certificates File Created.');
                    }).catch(() => {
                        this.props.hideLoading();
                        this.showModal('Print All Donor Certificates', 'An error occured while printing.');
                    });
                } else {
                    this.props.hideLoading();
                    this.showModal('Print All Donor Certificates', 'An Error occured while printing.');
                }
            });
        });
    }

    printAllVouchers = () => {
        let { firstName, lastName, email, alias, buttons } = this.state;

        let isAvailable         = buttons[0] > 0;
        let isNotAvailable      = buttons[1] > 0;

        let donors              = this.state.donors.filter(d => d.hasDonated && d.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.ReadyToPrint).length > 0);
        var voucherHolderList   = donors.flatMap(x => x.voucherHolders)
                                .filter(x => x.printStatus == AdpVoucherPrintStatus.ReadyToPrint)
                                .slice(0, 500)
                                .map(x => x.id);

        if (voucherHolderList.length == 0) {
            alert('All vouchers have been printed.');
            return;
        }

        this.props.showLoading('Creating vouchers, one moment please...').then(() => {
            this.props.printVouchers(voucherHolderList).then(response => {
                if (response.data.success) {
                    Promise.all([
                        this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable),
                        this.props.getBatches()]
                    ).then(([donorsResponse, batchResponse]) => {
                        let { donors } = donorsResponse.data.results;
                        let batches = batchResponse.data.results;

                        this.setState({
                            donors,
                            batches
                        })

                        this.props.hideLoading();
                        this.showModal('Print All Voucher Certificates', 'Certificates File Created.');
                    }).catch(() => {
                        this.props.hideLoading();
                        this.showModal('Print All Voucher Certificates', 'An error occured while printing.');
                    });
                }
                else {
                    this.props.hideLoading();
                    this.showModal('Print All Voucher Certificates', 'An error occured while printing.');
                }
            });
        });
    }

    showModal = (title: string, message: string) => {
        this.setState({
            modal: {
                show: true,
                title,
                message
            }
        });
    }

    handleConfirmPrintAllDonorCertificates = () => {
        let donors = this.state.donors.filter(x => x.hasDonated == true && x.printStatus == AdpVoucherPrintStatus.ReadyToPrint);

        this.setState({
            confirm: {
                show: true,
                action: ConfirmAction.PrintAllDonorCertificates,
                title: 'Print All Donor Certificates',
                message: 'Are you sure you want to print all donor certificates?',
                list: donors
            }
        });
    }

    handleConfirmPrintAllVoucherCertificates = () => {
        let voucherHolders = this.state.donors.filter(x => x.hasDonated).flatMap(d => d.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.ReadyToPrint).map(vh => vh));

        this.setState({
            confirm: {
                show: true,
                action: ConfirmAction.PrintAllVoucherCertificates,
                title: 'Print All Voucher Certificates',
                message: 'Are you sure you want to print all voucher certificates?',
                list: voucherHolders
            }
        });
    }

    handleDonorAction = (donorId: number, currentPrintStatus: AdpVoucherPrintStatus) => {
        let { firstName, lastName, email, alias, buttons } = this.state;

        let isAvailable = buttons[0] > 0;
        let isNotAvailable = buttons[1] > 0;

        let nextPrintStatus: AdpVoucherPrintStatus = currentPrintStatus + 1;

        if (currentPrintStatus == AdpVoucherPrintStatus.ReadyToPrint) {
            let donorIds = [donorId];

            this.props.showLoading('Creating donor certificate, one moment please...').then(() => {
                this.props.printDonorCertificates(donorIds).then(response => {
                    if (response.data.success) {
                        Promise.all([
                            this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable),
                            this.props.getBatches()]
                        ).then(([getAdpDonorsResponse, batchResponse]) => {
                            let { donors } = getAdpDonorsResponse.data.results;
                            let batches = batchResponse.data.results;
                            let hasCertsAlreadyMarkedSent = this.showDisabledButtonsAlert(this.state.userId, donors);

                            this.setState({
                                donors,
                                batches,
                                hasCertsAlreadyMarkedSent
                            });

                            this.props.hideLoading();
                            this.showModal('Donor', 'Printing Complete.');
                        }).catch(() => {
                            this.props.hideLoading();
                            this.showModal('Donor', 'An error occured while printing.');
                        });
                    } else {
                        this.props.hideLoading();
                        this.showModal('Donor', 'An error occured while printing.');
                    }
                });
            });
        } else {
            this.props.showLoading('Updating status, one moment please...').then(() => {
                this.props.updateDonorPrintStatus(donorId, nextPrintStatus).then(response => {
                    if (response.data.success) {
                        this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable).then(response => {
                            this.setState({
                                donors: response.data.results.donors
                            })
                        });
                    }
                    this.props.hideLoading();
                }).catch(() => {
                    this.props.hideLoading();
                    this.showModal('Donor', 'An error occured while updating status.');
                });;
            });
        }
    }

    handleVoucherHolderAction = (voucherHolderId: number, currentPrintStatus: AdpVoucherPrintStatus) => {
        let { firstName, lastName, email, alias, buttons } = this.state;

        let isAvailable = buttons[0] > 0;
        let isNotAvailable = buttons[1] > 0;

        let nextPrintStatus: AdpVoucherPrintStatus = currentPrintStatus + 1;

        if (currentPrintStatus == AdpVoucherPrintStatus.ReadyToPrint) {
            let voucherHolderIds = [voucherHolderId];

            this.props.showLoading('Creating voucher, one moment please...').then(() => {
                this.props.printVouchers(voucherHolderIds).then((response: IAdpCertificatePrintResponse) => {
                    if (response.data.success) {
                        Promise.all([
                            this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable),
                            this.props.getBatches()
                        ])
                            .then(([donorsResponse, batchResponse]) => {
                                let { donors } = donorsResponse.data.results;
                                let batches = batchResponse.data.results;

                                this.setState({
                                    donors,
                                    batches
                                })

                                this.props.hideLoading();
                                this.showModal('Voucher Holder', 'Printing Complete.');
                            }).catch(() => {
                                this.props.hideLoading();
                                this.showModal('Voucher Holder', 'An error occured while printing.');
                            });
                    } else {
                        this.props.hideLoading();
                        this.showModal('Voucher Holder', 'An error occured while printing.');
                    }
                });
            });
        } else {
            this.props.showLoading('Updating status, one moment please...').then(() => {
                this.props.updateVoucherHolderPrintStatus(voucherHolderId, nextPrintStatus).then((response: IBaseResponse) => {
                    if (response.data.success) {
                        this.props.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable).then(getAdpDonorsResponse => {
                            this.setState({
                                donors: getAdpDonorsResponse.data.results.donors
                            })
                        });
                    }
                    this.props.hideLoading();
                }).catch(() => {
                    this.props.hideLoading();
                    this.showModal('Voucher Holder', 'An error occured while updating status.');
                });
            });
        }
    }

    handlePrintVoucher = (el: React.FormEvent<HTMLButtonElement>) => {
        let adpVoucherHolder = parseInt(el.currentTarget.value);
        let voucherHolderIds: number[] = [adpVoucherHolder];

        this.props.showLoading('Getting data, one moment please...').then(() => {
            this.props.printVouchers(voucherHolderIds).then(response => {
                let { manifestLink, pdfLink } = response.data.results;

                if (response.data.success) {
                    this.props.getBatches().then(batchResponse => {
                        let batches = batchResponse.data.results;

                        this.setState({
                            manifestLink,
                            pdfLink,
                            batches
                        })
                    });
                }
            });
        });
    }

    handleToggleShowAllRows = () => {
        this.setState({
            showCompletedRows: !this.state.showCompletedRows
        }, () => {
            this.getData();
        });
    }

    handleHideModal = () => {
        this.setState({
            modal: {
                show: false,
                title: '',
                message: ''
            }
        });
    }

    handleRefreshList = (firstName: string, lastName: string, email: string, alias: string, buttons: number[]) => {
        this.setState({
            firstName,
            lastName,
            email,
            alias,
            buttons
        }, () => {
            let { hostname, protocol, port } = window.location;

            var newUrl = `${protocol}//${hostname}:${port}/adp-donor?firstName=${firstName}&lastName=${lastName}&email=${email}&alias=${alias}&buttons=${buttons.join(',')}`;

            window.history.pushState({}, '', newUrl);

            this.getData();
        });
    }

    handleSearchChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        this.setState({
            search: e.currentTarget.value
        });
    }

    handleClearSearch = () => {
        this.setState({
            search: ''
        });
    }

    handleStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            status: parseInt(e.currentTarget.value)
        });
    }

    handleDonorStatusChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            donorStatus: parseInt(e.currentTarget.value)
        });
    }

    handleConfirmYes = () => {
        let action = this.state.confirm.action;

        this.setState({
            confirm: {
                show: false,
                action: ConfirmAction.PrintAllDonorCertificates,
                title: '',
                message: '',
                list: []
            }
        }, () => {
            if (action == ConfirmAction.PrintAllDonorCertificates) {
                this.printAllDonorCertificates();
            }

            if (action == ConfirmAction.PrintAllVoucherCertificates) {
                this.printAllVouchers();
            }
        });
    }

    handleConfirmNo = () => {
        this.setState({
            confirm: {
                show: false,
                action: ConfirmAction.PrintAllDonorCertificates,
                title: '',
                message: '',
                list: []
            }
        });
    }

    handleDownloadManifest = (batch: IAdpBatchInfo) => {
        this.props.downloadBatchManifest(batch).then(response => {
            downloadFile(response.data, `batch-manifest-${batch.id}.pdf`, 'application/pdf');
        });
    }

    handleDownloadPdf = (batch: IAdpBatchInfo) => {
        let type = batch.batchTypeId == AdpVoucherBatchType.VoucherHolder ? 'voucher-holder' : 'donor';

        this.props.downloadBatchPdf(batch).then(response => {
            downloadFile(response.data, `batch-${type}-${batch.id}.pdf`, 'application/pdf');
        });
    }

    handleDownloadCsv = (batch: IAdpBatchInfo) => {
        let type = batch.batchTypeId == AdpVoucherBatchType.VoucherHolder ? 'voucher-holder' : 'donor';
        this.props.downloadBatchCsv(batch).then(response => {
            downloadFile(response.data, `batch-${type}-${batch.id}.csv`, 'text/csv');
        });
    }

    render() {
        const filteredData = this.getFilteredData();

        const printableDonorCertificates = this.state.donors.filter(x => x.hasDonated && x.printStatus == AdpVoucherPrintStatus.ReadyToPrint).length;
        const disablePrintAllDonorCertificates = printableDonorCertificates == 0;
        const printableVoucherCertificates = this.state.donors.filter(d => d.hasDonated).flatMap(d => d.voucherHolders.filter(vh => vh.printStatus == AdpVoucherPrintStatus.ReadyToPrint).map(vh => vh.id)).length;
        const disablePrintVoucherCertificates = printableVoucherCertificates == 0;

        return (
            <>
                <div className='container'>
                    {this.state.hasCertsAlreadyMarkedSent && (
                        <Alert bsStyle='danger'>Some 'Mark Sent' buttons are disabled as you were the user who marked that certificate as sent the first time.</Alert>
                    )}

                    <Well bsSize='sm'>
                        <h4 style={{ marginTop: 0 }}>Search</h4>

                        <Filter
                            firstName={this.state.firstName}
                            lastName={this.state.lastName}
                            email={this.state.email}
                            alias={this.state.alias}
                            buttons={this.state.buttons}
                            onRefresh={this.handleRefreshList}
                        />
                    </Well>

                    <Alert bsSize='sm' bsStyle='info' style={{ display: 'flex', justifyContent: 'center', padding: 9 }}>
                        <div style={{ marginRight: 20 }}><strong>Total Donors: </strong> {this.state.totalDonors}</div>
                        <div style={{ marginRight: 20 }}><strong>Total Donors With Voucher Holders: </strong> {this.state.totalDonorsWithVoucherHolders}</div>
                        <div><strong>Total Voucher Holders: </strong> {this.state.totalVoucherHolders}</div>
                    </Alert>

                    <Well bsSize='sm' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div>
                            <Button bsStyle='primary' bsSize='sm' style={{ marginRight: 10 }} disabled={disablePrintAllDonorCertificates} onClick={this.handleConfirmPrintAllDonorCertificates}>Print All<br />Donor Certificates ({printableDonorCertificates})</Button>
                            <Button bsStyle='primary' bsSize='sm' disabled={disablePrintVoucherCertificates} onClick={this.handleConfirmPrintAllVoucherCertificates}>Print All<br />Voucher Certificates ({printableVoucherCertificates})</Button>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ marginRight: 10 }}>
                                <InputGroup bsSize='small'>
                                    <InputGroup.Addon>Search:</InputGroup.Addon>
                                    <FormControl
                                        placeholder='Start typing...'
                                        value={this.state.search}
                                        onChange={this.handleSearchChange}
                                    />
                                    <InputGroup.Button><Button bsSize='sm' onClick={this.handleClearSearch}><Glyphicon glyph='remove' /></Button></InputGroup.Button>
                                </InputGroup>
                            </div>

                            <div style={{ marginRight: 10 }}>
                                <InputGroup bsSize='small'>
                                    <InputGroup.Addon>Status:</InputGroup.Addon>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.status}
                                        onChange={this.handleStatusChange}
                                    >
                                        <option value={0}>- All -</option>
                                        <option value={1}>Donors Pending Printing</option>
                                        <option value={5}>Donors Pending Verification</option>
                                        <option value={2}>Recipients Pending Printing</option>
                                        <option value={6}>Recipients Pending Verification</option>
                                        <option value={3}>Donors Printed</option>
                                        <option value={4}>Recipients Printed</option>
                                    </FormControl>
                                </InputGroup>
                            </div>

                            <InputGroup bsSize='small'>
                                <InputGroup.Addon>Donor Status:</InputGroup.Addon>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.donorStatus}
                                    onChange={this.handleDonorStatusChange}
                                >
                                    <option value={-1}>- All -</option>
                                    <option value={1}>Donated</option>
                                    <option value={0}>Pending Donation</option>
                                </FormControl>
                            </InputGroup>
                        </div>
                    </Well>

                    <Panel bsStyle='info' defaultExpanded>
                        <Panel.Heading>
                            <PanelTitleWrapper toggle>
                                <div>Donors &amp; Voucher Holders</div>
                                <div style={{ fontSize: 12 }}>(click to expand/contract)</div>
                            </PanelTitleWrapper>
                        </Panel.Heading>
                        <Panel.Collapse>
                            <TableContainer>
                                <TableWrapper condensed>
                                    <thead>
                                        <tr style={{ backgroundColor: '#022644', color: 'white' }}>
                                            <th style={{ textAlign: 'center' }}>Type</th>
                                            <th style={{ textAlign: 'center' }}>Donor<br />Alias</th>
                                            <th style={{ textAlign: 'center' }}>Donation<br />Date</th>
                                            <th style={{ textAlign: 'center' }}>Registered</th>
                                            <th style={{ textAlign: 'center' }}>R Alias</th>
                                            <th style={{ textAlign: 'center' }}>Name</th>
                                            <th style={{ textAlign: 'center' }}>VH Age</th>
                                            <th style={{ textAlign: 'center' }}>VH Type</th>
                                            <th style={{ textAlign: 'center' }}>Action</th>
                                        </tr>
                                    </thead>

                                    {filteredData.map((adpDonor, index) =>
                                        <tbody>
                                            <DonorRow
                                                key={index}
                                                donor={adpDonor}
                                                userId={this.state.userId}
                                                status={this.state.status}
                                                onDonorAction={this.handleDonorAction}
                                                onVoucherHolderAction={this.handleVoucherHolderAction}
                                            />
                                        </tbody>
                                    )}

                                    {filteredData.length == 0 && (
                                        <tbody>
                                            <tr>
                                                <td colSpan={8} className='text-center'>
                                                    No donors nor voucher holders found...
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                                </TableWrapper>
                            </TableContainer>
                        </Panel.Collapse>
                    </Panel>

                    <Panel bsStyle='info' defaultExpanded>
                        <Panel.Heading>
                            <PanelTitleWrapper toggle>
                                <div>Print Batches</div>
                                <div style={{ fontSize: 12 }}>(click to expand/contract)</div>
                            </PanelTitleWrapper>
                        </Panel.Heading>
                        <Panel.Collapse>
                            <TableContainer>
                                <TableWrapper condensed>
                                    <thead>
                                        <tr style={{ backgroundColor: '#022644', color: 'white' }}>
                                            <th style={{ textAlign: 'center' }}>Batch #</th>
                                            <th style={{ textAlign: 'center' }}>Date Created</th>
                                            <th style={{ textAlign: 'center' }}>Type</th>
                                            <th style={{ textAlign: 'center' }}># of Vouchers</th>
                                            <th style={{ textAlign: 'center' }}></th>
                                            <th style={{ textAlign: 'center' }}></th>
                                            <th style={{ textAlign: 'center' }}></th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.batches.map((batchInfo, index) =>
                                            <BatchInfoRow
                                                key={index}
                                                batchInfo={batchInfo}
                                                onDownloadManifest={this.handleDownloadManifest}
                                                onDownloadPdf={this.handleDownloadPdf}
                                                onDownloadCsv={this.handleDownloadCsv}
                                            />
                                        )}
                                    </tbody>
                                </TableWrapper>
                            </TableContainer>
                        </Panel.Collapse>
                    </Panel>
                </div>

                <Message
                    show={this.state.modal.show}
                    title={this.state.modal.title}
                    message={this.state.modal.message}
                    onOk={this.handleHideModal}
                />

                <ConfirmPrint
                    show={this.state.confirm.show}
                    title={this.state.confirm.title}
                    message={this.state.confirm.message}
                    list={this.state.confirm.list}
                    action={this.state.confirm.action}
                    onYes={this.handleConfirmYes}
                    onNo={this.handleConfirmNo}
                />
            </>
        )
    }
}

const mapStateToProps = (appState: IApplicationState): IAdpDonorStateProps => {
    return {
        userId: appState.app.user.id
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IAdpDonorDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getDonors: (firstName, lastName, email, alias, isAvailable, isNotAvailable) => {
            return dispatch(AdpDonorActionCreators.getDonors(firstName, lastName, email, alias, isAvailable, isNotAvailable));
        },
        printDonorCertificates: (donorIds) => {
            return dispatch(AdpDonorActionCreators.printDonorCertificate(donorIds));
        },
        printVouchers: (voucherHolderIds) => {
            return dispatch(AdpDonorActionCreators.printVouchers(voucherHolderIds));
        },
        getManifest: (url) => {
            return dispatch(AdpDonorActionCreators.getManifest(url));
        },
        getBatches: () => {
            return dispatch(AdpDonorActionCreators.getBatches());
        },
        updateDonorPrintStatus: (donorId, printStatus) => {
            return dispatch(AdpDonorActionCreators.updateDonorPrintStatus(donorId, printStatus));
        },
        updateVoucherHolderPrintStatus: (voucherHolderId, printStatus) => {
            return dispatch(AdpDonorActionCreators.updateVoucherHolderPrintStatus(voucherHolderId, printStatus));
        },
        resetAll: () => {
            return dispatch(AdpDonorActionCreators.resetAll());
        },
        downloadBatchManifest: (batchInfo) => {
            return dispatch(AdpDonorActionCreators.downloadBatchManifest(batchInfo));
        },
        downloadBatchPdf: (batchInfo) => {
            return dispatch(AdpDonorActionCreators.downloadBatchPdf(batchInfo));
        },
        downloadBatchCsv: (batchInfo) => {
            return dispatch(AdpDonorActionCreators.downloadBatchCsv(batchInfo));
        },
    };
}

export default connect<IAdpDonorStateProps, IAdpDonorDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(AdpDonor);

